import { darken, lighten, makeStyles } from "@material-ui/core/styles";
export var useStyles = makeStyles(function (theme) { return ({
    tableContainer: {
        background: theme.palette.background.paper,
        padding: 0
    },
    table: {
        minWidth: 650,
        width: "inherit",
        background: theme.palette.background.paper,
        position: "relative"
    },
    theader: {
        maxHeight: "48px",
        position: "sticky",
        top: 0,
        background: theme.palette.type === "dark"
            ? lighten(theme.palette.background.paper, 0.03)
            : darken(theme.palette.background.paper, 0.03),
        zIndex: 3
    },
    columnFilterIcon: {
        margin: "15px 5px",
        width: "18px",
        cursor: "pointer"
    },
    filterContainer: {
        display: "flex",
        alignItems: "center",
        position: "relative"
    },
    filterWrapper: {
        position: "absolute",
        top: "40px",
        right: 0,
        background: theme.palette.background.paper,
        padding: "10px"
    }
}); });
//# sourceMappingURL=styles.js.map